export class SummaryDetailsModel {
  comment: string = null;
  agreement: string = null;
  coverage : string=null;
}